export default "__VITE_ASSET__nXhEINva__"